import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=f609416a&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=f609416a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f609416a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f609416a')) {
      api.createRecord('f609416a', component.options)
    } else {
      api.reload('f609416a', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=f609416a&scoped=true&", function () {
      api.rerender('f609416a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2tHjLDGaRKl8o/JS/comp/SearchFilterTokens.vue"
export default component.exports